angular.module('am4').filter('facilityName', function(orgFacService) {
    return function(facId) {
        // Filters are sync. Get the value synchronously

        if (orgFacService.getFacilitiesDictionary().$$state.status !== 1) {
            throw new Error('Facility dictionary had no time to resolve!');
        }

        return orgFacService.getFacilitiesDictionary().$$state.value[facId];
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/facilityName.js